export default class Helper {
    public static javascriptReady() {
        return ((document.readyState === 'complete') && !document.body.matches(':animated'));
    }
}
